var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import AuthService, { privileges } from '@/shared/services/AuthService';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
var messages = defineMessages({
    EnterTag: {
        id: 'EnterTag',
        defaultMessage: 'Enter tag',
    },
});
export var TaskTagsMultiSelect = function (_a) {
    var selection = _a.selection, onChange = _a.onChange, placeholder = _a.placeholder, _b = _a.allowNew, allowNew = _b === void 0 ? false : _b, _c = _a.small, small = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var intl = useIntl();
    var _e = useState([]), items = _e[0], setItems = _e[1];
    useEffect(function () {
        var mounted = true;
        api.base.get("".concat(config.appUrls.tasks, "/api/Tags")).then(function (_a) {
            var data = _a.data;
            if (!mounted)
                return;
            setItems(data.map(function (_a) {
                var id = _a.id, name = _a.name;
                return ({ id: id, label: name });
            }).sort(dynamicSort('label')));
        }, function (error) {
            handleHttpError(intl)(error);
        });
        return function () {
            mounted = false;
        };
    }, [intl]);
    var canCreateTags = useMemo(function () {
        return AuthService.hasPermission({
            functionality: 'Tags',
            privilege: privileges.Create,
        });
    }, []);
    var findOrCreateTag = function (tagName) {
        return new Promise(function (resolve, reject) {
            var tag = items.find(function (t) { return t.label.toLowerCase() === tagName.toLowerCase(); });
            if (tag) {
                resolve(tag);
            }
            else {
                api.base.post("".concat(config.appUrls.tasks, "/api/Tags"), { name: tagName }).then(function (_a) {
                    var data = _a.data;
                    if (!data)
                        return reject();
                    var newTag = { id: data.id, label: data.name };
                    setItems(function (oldItems) { return __spreadArray(__spreadArray([], oldItems, true), [newTag], false).sort(dynamicSort('label')); });
                    resolve(newTag);
                }, reject);
            }
        });
    };
    var onCreateItem = function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!inputValue || !allowNew || !canCreateTags)
                        return [2 /*return*/];
                    return [4 /*yield*/, findOrCreateTag(inputValue)];
                case 1:
                    item = _a.sent();
                    if (!item)
                        return [2 /*return*/];
                    onChange(addItem(selection, item));
                    return [2 /*return*/];
            }
        });
    }); };
    var _f = splitItems(items, selection), selectedItems = _f[0], selectableItems = _f[1];
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: function (item) { return onChange(removeItem(selection, item)); }, onItemSelected: function (item) { return onChange(addItem(selection, item)); }, onCreateItem: allowNew && canCreateTags ? onCreateItem : undefined, items: selectableItems, placeholder: placeholder || intl.formatMessage(messages.EnterTag), isSmall: small, disabled: disabled }));
};
